import {FC, useEffect, useId, useRef, useState} from 'react'
import {PartType} from '@dv5/domain'
import {partTypesTitle} from '../partTypes'
import './ChangePartTypeDialog.less'

interface Props {
    currentType: PartType
    onConfirm: (type: PartType) => void
    onCancel: () => void
}

export const ChangePartTypeDialog: FC<Props> = ({currentType, onConfirm, onCancel}) => {
    const dialogRef = useRef<HTMLDialogElement>(null)
    const titleId = useId()
    const selectId = useId()
    const [selectedType, setSelectedType] = useState<PartType | ''>('')
    const availableTypes = Object.values(PartType).filter(type => type !== currentType)
    const canConvert = selectedType !== '' && selectedType !== currentType

    useEffect(() => {
        const dialog = dialogRef.current
        dialog?.showModal()
        return () => dialog?.close()
    }, [])

    return (
        <dialog
            ref={dialogRef}
            className="change-part-type-dialog"
            aria-labelledby={titleId}
            onCancel={event => {
                event.preventDefault()
                onCancel()
            }}
        >
            <form onSubmit={event => {
                event.preventDefault()
                if (canConvert) onConfirm(selectedType)
            }}>
                <h3 id={titleId}>Change content type</h3>
                <p>Current type: <strong>{partTypesTitle[currentType]}</strong></p>
                <label htmlFor={selectId}>Convert to</label>
                <select id={selectId} value={canConvert ? selectedType : ''}
                        onChange={event => setSelectedType(event.target.value as PartType | '')}
                        autoFocus>
                    <option value="">Select a type...</option>
                    {availableTypes.map(type => (
                        <option key={type} value={type}>{partTypesTitle[type]}</option>
                    ))}
                </select>
                <div className="buttons">
                    <button type="button" onClick={onCancel}>Cancel</button>
                    <button type="submit" className="convert-button" disabled={!canConvert}>Convert</button>
                </div>
            </form>
        </dialog>
    )
}
